import React from "react"

interface AnchorNumberProps {
  additionalClassNames?: string
  contactNumber: string
  label?: string
  svgIcon?: string
  classNameModifier?: string
  showIcon?: boolean
  baseClassName: string
}

export const AnchorNumber = ({
  additionalClassNames = "",
  baseClassName,
  contactNumber,
  label,
  svgIcon,
  classNameModifier = "",
  showIcon = true,
}: AnchorNumberProps) => {
  return (
    <a
      href={`tel: ${contactNumber}`}
      className={`${baseClassName}${classNameModifier} ${additionalClassNames}`}
    >
      {label && <div className={`${baseClassName}-label`}>{label}</div>}
      {showIcon && svgIcon && (
        <span
          dangerouslySetInnerHTML={{ __html: svgIcon }}
          contentEditable="false"
          className="phone-svg-container"
        />
      )}
      <span className={`${baseClassName}-number`}>{contactNumber}</span>
    </a>
  )
}
